import { AxiosRequestConfig } from "axios";
import { CohesiveAPIClient } from "../../client";
import { route } from "../../utils";
import {
  InviteUserPayload,
  PendingInvite,
  PendingInvitesResponse,
} from "./types";

// Export types
export * from "./types";

const ENDPOINTS = {
  INVITES: {
    CREATE: "/api/v2/org/:organization_id/invite-user",
    LIST: "/api/v2/org/:organization_id/pending-invites",
    DELETE: "/api/v2/org/:organization_id/pending-invites/:invitation_id",
  },
};

export class InvitesAPI {
  private client: CohesiveAPIClient;

  constructor(client: CohesiveAPIClient) {
    this.client = client;
  }

  /**
   * Invite a user to the organization
   */
  async create(
    payload: InviteUserPayload,
    config?: AxiosRequestConfig,
  ): Promise<void> {
    const orgId = await this.client.getOrgID();

    await this.client.axios.post(
      route(ENDPOINTS.INVITES.CREATE, {
        organization_id: orgId || "",
      }),
      payload,
      config,
    );
  }

  /**
   * Get all pending invites in the organization
   */
  async list(config?: AxiosRequestConfig): Promise<PendingInvite[]> {
    const orgId = await this.client.getOrgID();

    const response = await this.client.axios.get<PendingInvitesResponse>(
      route(ENDPOINTS.INVITES.LIST, {
        organization_id: orgId || "",
      }),
      config,
    );
    return response.data.data.invites;
  }

  /**
   * Delete a pending invite
   */
  async delete(
    invitationId: string,
    config?: AxiosRequestConfig,
  ): Promise<void> {
    const orgId = await this.client.getOrgID();

    await this.client.axios.delete(
      route(ENDPOINTS.INVITES.DELETE, {
        organization_id: orgId || "",
        invitation_id: invitationId,
      }),
      config,
    );
  }
}
